export default __webpack_public_path__ + "static/media/442.e9f270d4.svg";